import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Root = styled.div`
  width: 100%;
  padding: 48px 24px;
  
  @media (min-width: 1024px) {
    padding: 72px 48px;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: 48px;
  
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    gap: 72px;
  }
`;

export const ImageSection = styled.div`
  width: 100%;
`;

export const ImageGallery = styled.div`
  display: flex;
  gap: 16px;
  
  @media (max-width: 1023px) {
    flex-direction: column-reverse;
  }
`;

export const ThumbnailList = styled.div`
  display: flex;
  gap: 8px;
  
  @media (max-width: 1023px) {
    flex-direction: row;
    overflow-x: auto;
  }
  
  @media (min-width: 1024px) {
    flex-direction: column;
    width: 80px;
  }
`;

export const Thumbnail = styled.button`
  width: 80px;
  height: 80px;
  border: 2px solid ${props => props.$active ? '#E1000F' : '#E0E0E0'};
  background: none;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.2s ease;
  flex-shrink: 0;
  
  &:hover {
    border-color: #E1000F;
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const MainImage = styled.div`
  flex: 1;
  background-color: #000;
  aspect-ratio: 604 / 752;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const BrandName = styled(Link)`
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #E1000F;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const ClassName = styled.h1`
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 400;
  font-size: 34px;
  line-height: 35px;
  margin: 0;
  
  @media (min-width: 1024px) {
    font-size: 40px;
    line-height: 48px;
  }
`;

export const Points = styled.div`
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #000;
`;

export const DetailsList = styled.dl`
  display: grid;
  gap: 16px;
  margin: 0;
  padding: 0 0;
`;

export const DetailsItem = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 16px;
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 4px;
  }
`;

export const DetailsLabel = styled.dt`
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 700;
  font-size: 17px;
  line-height: 20px;
  color: #000;
  margin: 0;
`;

export const DetailsValue = styled.dd`
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 20px;
  color: #555;
  margin: 0;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const SaveButton = styled.button`
  width: 262px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 2px 16px 2px 20px;
  border-radius: 16.46px;
  background-color: #E1000F;
  color: #fff;
  border: none;
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
  
  &:hover {
    background-color: #C00000;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const FavoriteButton = styled.button`
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.$isFavorite ? '#E1000F' : '#fff'};
  color: ${props => props.$isFavorite ? '#fff' : '#E1000F'};
  padding: 2px 16px 2px 20px;
  border-radius: 16.46px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #E1000F;
    color: #fff;
  }
  
  svg {
    width: 24px;
    height: 24px;
  }
`;

export const TicketNote = styled.p`
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #555;
  margin: 0;
`;

export const DescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  p {
    font-family: "Yellix", system-ui, sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #333;
    margin: 0;
  }
  
  strong {
    color: #E1000F;
  }
`;

export const SectionTitle = styled.h2`
  font-family: "Yellix", system-ui, sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: #000;
  margin: 0;
`;

export const BulletList = styled.ul`
  margin: 0;
  padding-left: 24px;
  
  li {
    font-family: "Yellix", system-ui, sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #333;
    margin-bottom: 8px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
